import { getDoc, onSnapshot, query, where } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { functions, collectionRef, docRef } from '../firebase/config';
import { COLLECTIONS } from '../utils/constants';
import { normalizeEmail } from '../utils/emailUtils';

const KNOWN_ERROR_CODES = [
  'invalid-argument', 'already-exists', 'resource-exhausted',
  'failed-precondition', 'not-found', 'permission-denied',
];

const toUserMessage = (err, fallback) => {
  const code = String(err?.code || '').replace(/^functions\//, '');
  return KNOWN_ERROR_CODES.includes(code) && err?.message ? err.message : fallback;
};

/** Öğrenci ön kaydı — kayıt alan eğitmenlerin onayına düşer */
export async function requestStudentSignup(form) {
  try {
    const { data } = await httpsCallable(functions, 'requestStudentSignup')({
      ...form,
      email: normalizeEmail(form.email),
    });
    return { ok: true, status: data?.status || 'created' };
  } catch (err) {
    const code = String(err?.code || '').replace(/^functions\//, '');
    return {
      ok: false,
      code,
      error: toUserMessage(err, 'Kayıt gönderilemedi. Lütfen biraz sonra tekrar deneyin.'),
    };
  }
}

export async function approveStudentSignup(signupId) {
  try {
    const { data } = await httpsCallable(functions, 'approveStudentSignup')({ signupId });
    return { ok: true, studentId: data?.studentId };
  } catch (err) {
    return { ok: false, error: toUserMessage(err, 'Onaylanamadı. Lütfen tekrar deneyin.') };
  }
}

export async function rejectStudentSignup(signupId) {
  try {
    await httpsCallable(functions, 'rejectStudentSignup')({ signupId });
    return { ok: true };
  } catch (err) {
    return { ok: false, error: toUserMessage(err, 'Reddedilemedi. Lütfen tekrar deneyin.') };
  }
}

/** Eğitmenin onay bekleyen ön kayıtları (en yeni üstte); talep birden çok eğitmene düşebilir */
export function subscribePendingSignups(instructorId, onChange, onError) {
  return onSnapshot(
    query(
      collectionRef(COLLECTIONS.STUDENT_SIGNUPS),
      where('instructorIds', 'array-contains', instructorId)
    ),
    (snap) => {
      const list = snap.docs
        .map((d) => ({ id: d.id, ...d.data() }))
        .sort((a, b) => (Number(b.createdAt) || 0) - (Number(a.createdAt) || 0));
      onChange(list);
    },
    onError
  );
}

/** Giriş yapan ama profili olmayan kullanıcının bekleyen ön kaydı var mı */
export async function hasPendingSignup(email) {
  const id = normalizeEmail(email);
  if (!id) return false;
  try {
    return (await getDoc(docRef(COLLECTIONS.STUDENT_SIGNUPS, id))).exists();
  } catch {
    return false;
  }
}
